import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SearchResults from './pages/SearchResults';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import { ThemeProvider } from './pages/components/ThemeContext';

const App: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

    const handleLogin = (): void => {
        setIsLoggedIn(true);
    };

    return (
        <ThemeProvider>
            <div className="font-sans antialiased">
                <Routes>
                    <Route
                        path="/login"
                        element={
                            isLoggedIn ?
                                <Navigate to="/" replace /> :
                                <LoginPage onLogin={handleLogin} />
                        }
                    />
                    <Route
                        path="/signup"
                        element={
                            isLoggedIn ?
                                <Navigate to="/" replace /> :
                                <LoginPage onLogin={handleLogin} isSignUp={true} />
                        }
                    />
                    <Route
                        path="/"
                        element={
                            isLoggedIn ?
                                <Home setSearchQuery={setSearchQuery} /> :
                                <Navigate to="/login" replace />
                        }
                    />
                    <Route
                        path="/search-results"
                        element={
                            isLoggedIn ?
                                <SearchResults searchQuery={searchQuery} /> :
                                <Navigate to="/login" replace />
                        }
                    />
                </Routes>
            </div>
        </ThemeProvider>
    );
}

export default App;
